import moment from "moment";
import "moment-duration-format";
import { trackPromise } from "react-promise-tracker";
import { create } from "zustand";
import { getNotificationStyle } from "../common/notification";
import { IAdhocDetails, ITripplanDriverWeb } from "../model/CommonModel";
import {
  IAssignDriver,
  IDeleteTripSchedule,
  IRefresh,
  ITripActual,
  ITripActualDetails,
  ITripExceptionOtp,
  ITripPlanBan,
  ITripPlanDetail,
  ITripPlanInitial,
  ITripPlanStore,
  ITripRequest,
  ITripSchedule,
  ITripScheduleDetail,
  ITripSearchRequest,
} from "../model/TripPlanModel";
import {
  AssignScheduleDriverService,
  ClosedTripPlanService,
  CompleteTripPlanService,
  DeleteTripActualService,
  GenerateTripOTPService,
  GetDriverDetailByIdService,
  GetTripActualScheduleService,
  GetTripByNumberService,
  GetTripCodeService,
  GetTripHistoryService,
  GetTripOtpListService,
  GetTripPlanBanService,
  GetTripPlanDetailByIdService,
  GetTripPlanDriverListByIdService,
  GetTripPlanFilesService,
  GetTripPlanService,
  GetTripPlanWaybillService,
  GetTripScheduleService,
  GetWaybillByTripPlanService,
  PrintTripPlanService,
  PrintTripSheetService,
  PrintManifestSheetService,
  RefreshActualTripService,
  SaveTripPlanDriverWebService,
  SaveTripScheduleService,
  UpdateAdhocDetailService,
  UpdateTripActualService,
  UpdateTripDetailService,
  UpdateTripPlanService,
  UpdateTripScheduleService,
  GetVehicleListService,
  PrintVehicleManifestService,
  GetTripExceptionService,
} from "../services/trip-plan-service";
import {
  ACTIVE_TRIP_STATUS_ID,
  TWO_HUNDRED_SUCCESS_CODE,
  downloadURL,
  vehicleListType,
} from "../utils/app-common";
import { convertMillisToDateMoment } from "../utils/luxon";
import { ITripPlanRequest } from "./../model/TripPlanModel";
import {
  DeleteTripPlanByIdService,
  GetTripLoadTypeService,
  GetTripPlanByIdService,
  GetTripTypeService,
  SaveTripPlanService,
} from "./../services/trip-plan-service";
import { responseData } from "./common";
import { getTrailerListService } from "../services/master-services";

const initialValue: ITripPlanInitial = {
  tripPlanList: [],
  tripPlans: {
    totalPages: 0,
    isLast: false,
    numberOfElements: 0,
    page: 0,
    totalNumberOfAllElements: 0,
  },
  tripCodeList: [],
  tripHistoryList: [],
  tripTypeList: [],
  tripLoadTypeList: [],
  tripPlan: {},
  tripPlanWayBillList: [],
  tripPlanWayBills: [],
  tripSchedules: [],
  tripActuals: [],
  tripPlanFilesList: {},
  tripPlanResponse: undefined,
  tripStatus: undefined,
  tripplanBanList: [],
  tripplanDetailList: [],
  tripOtpList: {},
  assignDriverStatus: undefined,
  updateTripScheduleStatus: undefined,
  updateTripActualStatus: undefined,
  saveTripScheduleStatus: undefined,
  tripplanDriverList: [],
  driverDetail: {},
  truckList: [],
  trailerHeadList: [],
  trailerList: [],
  tripExceptionList: [],
  tripPlanDashboard: {
    dashboardFilter: {
      lessThanIdleTimeFilter: 15,
      selectedLocation: [0, 0],
    },
  },
};

let TripPlanStore = create<ITripPlanStore>((set: any, get: any) => ({
  ...initialValue,
  GetTripPlanAction: async ({ page, size }) => {
    const response = await GetTripPlanService({ page, size });
    if (response?.data?.statusCode === TWO_HUNDRED_SUCCESS_CODE) {
      const {
        totalPages,
        isLast,
        numberOfElements,
        page: pageNumber,
        totalNumberOfAllElements,
      } = response?.data || {};
      set({
        tripPlanList: responseData(response?.data),
        tripPlans: {
          totalPages,
          isLast,
          numberOfElements,
          page: pageNumber,
          totalNumberOfAllElements,
        },
      });
    }
  },
  GetTripByNumberAction: async (request: ITripSearchRequest) => {
    const response = await GetTripByNumberService(request);
    if (response?.data?.statusCode === TWO_HUNDRED_SUCCESS_CODE) {
      const {
        totalPages,
        isLast,
        numberOfElements,
        page: pageNumber,
        totalNumberOfAllElements,
      } = response?.data || {};
      set({
        tripPlanList: responseData(response?.data),
        tripPlans: {
          totalPages,
          isLast,
          numberOfElements,
          page: pageNumber,
          totalNumberOfAllElements,
        },
      });
    }
  },
  GetTripPlanByIdAction: async (id: number) => {
    const response = await GetTripPlanByIdService(id);
    const convertedResponse = responseData(response?.data);
    const manipulatedResponse = {
      ...convertedResponse,
      ata: convertedResponse?.ata
        ? convertMillisToDateMoment(convertedResponse?.ata)
        : undefined,
      eta: convertedResponse?.eta
        ? convertMillisToDateMoment(convertedResponse?.eta)
        : undefined,
      etd: convertedResponse?.etd
        ? convertMillisToDateMoment(convertedResponse?.etd)
        : undefined,
    };
    set({ tripPlan: manipulatedResponse });
  },
  GetTripCodeAction: async () => {
    const response = await GetTripCodeService();
    set({ tripCodeList: responseData(response?.data) });
  },
  GetTripTypeAction: async () => {
    const response = await GetTripTypeService();
    set({ tripTypeList: responseData(response?.data) });
  },
  SaveTripPlanAction: async (data: ITripPlanRequest) => {
    const response = await SaveTripPlanService(data);
    const { statusCode } = response?.data || {};
    if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
      getNotificationStyle(response);
      set({ tripPlanResponse: statusCode });
    }
  },
  UpdateTripPlanAction: async (data: ITripPlanRequest, id: number) => {
    const response = await trackPromise(
      UpdateTripPlanService(data, id),
      "update-trip-details",
    );
    const { statusCode } = response?.data || {};
    if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
      getNotificationStyle(response);
      trackPromise(
        get().GetTripPlanByIdAction(id),
        "trip-plan-by-id-list-area",
      );
    }
  },
  DeleteTripPlanByIdAction: async (id: number) => {
    const response = await DeleteTripPlanByIdService(id);
    const { statusCode } = response?.data || {};
    getNotificationStyle(response);
    if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
      trackPromise(get().GetTripPlanAction(), "tripplan-list-area");
    }
  },
  GetTripLoadTypeAction: async () => {
    const response = await GetTripLoadTypeService();
    set({ tripLoadTypeList: responseData(response?.data) });
  },
  GetTripPlanWaybillAction: async (id: number) => {
    const response = await GetTripPlanWaybillService(id);
    set({ tripPlanWayBillList: responseData(response?.data) });
  },
  GetTripPlanFilesAction: async (id: number) => {
    const response = await GetTripPlanFilesService(id);
    set({ tripPlanFilesList: responseData(response?.data) });
  },
  CompleteTripPlanAction: async (request: ITripRequest) => {
    const response = await CompleteTripPlanService(request);
    const { statusCode } = response?.data || {};
    if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
      set({ tripStatus: statusCode });
      getNotificationStyle(response?.data);
    }
  },
  CloseTripPlanAction: async (request: ITripRequest) => {
    const response = await ClosedTripPlanService(request);
    const { statusCode } = response?.data || {};
    if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
      getNotificationStyle(response);
    }
  },
  GetTripHistoryAction: async (id: number | undefined) => {
    const response = await GetTripHistoryService(id);
    const convertedResponse = responseData(response?.data);
    set({ tripHistoryList: convertedResponse });
  },
  GetTripPlanBanAction: async (id: number) => {
    const response = await GetTripPlanBanService(id);
    const converted = responseData(response?.data).map(
      (item: ITripPlanBan) => ({
        ...item,
        banStartLocation:
          item.banStartLatitude && item.banStartLongitude
            ? `${item.banStartLatitude} , ${item.banStartLongitude}`
            : "",
        banEndLocation:
          item.banEndLatitude && item.banEndLongitude
            ? `${item.banEndLatitude} , ${item.banEndLongitude}`
            : "",
      }),
    );
    set({ tripplanBanList: converted });
  },
  GetTripPlanDetailByIdAction: async (id: number) => {
    const response = await GetTripPlanDetailByIdService(id);
    const convertedResponse = responseData(response?.data);
    let delayDptTime: number = 0;
    let delayArrTime: number = 0;
    // if (convertedResponse?.etd || convertedResponse?.tripAtd)
    //     delayDptTime = getTime(convertedResponse?.etd, convertedResponse?.tripAtd);
    // if (convertedResponse?.eta || convertedResponse?.tripAta)
    //     delayArrTime = getTime(convertedResponse?.eta, convertedResponse?.tripAta);
    if (
      convertedResponse?.etd !== undefined ||
      convertedResponse?.tripAtd !== undefined
    )
      delayDptTime = Math.abs(
        new Date(convertedResponse?.etd).getTime() -
          new Date(convertedResponse?.tripAtd).getTime(),
      );
    if (
      convertedResponse?.eta !== undefined ||
      convertedResponse?.tripAta !== undefined
    )
      delayArrTime = Math.abs(
        new Date(convertedResponse?.eta).getTime() -
          new Date(convertedResponse?.tripAta).getTime(),
      );
    const modifiedResponse = {
      ...convertedResponse,
      etd: convertMillisToDateMoment(convertedResponse?.etd),
      eta: convertMillisToDateMoment(convertedResponse?.eta),
      tripAtd:
        convertedResponse?.tripAtd !== undefined
          ? convertMillisToDateMoment(convertedResponse?.tripAtd)
          : null,
      tripAta:
        convertedResponse?.tripAta !== undefined
          ? convertMillisToDateMoment(convertedResponse?.tripAta)
          : null,
      delayDeptTime: !isNaN(delayDptTime)
        ? Math.round(delayDptTime / 3600000)
        : null,
      delayArrivalTime: !isNaN(delayArrTime)
        ? Math.round(delayArrTime / 3600000)
        : null,
    };
    set({ tripplanDetailList: modifiedResponse });
  },
  UpdateTripDetailAction: async (data: ITripPlanDetail, id: number) => {
    const response = await UpdateTripDetailService(data, id);
    const { statusCode } = response?.data || {};
    if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
      trackPromise(
        get().GetTripPlanByIdAction(id),
        "trip-plan-by-id-list-area",
      );
      getNotificationStyle(response);
    }
  },
  GenerateTripOTPAction: async (data: ITripExceptionOtp) => {
    const response = await trackPromise(
      GenerateTripOTPService(data),
      "submit-trip-exception-area",
    );
    const { statusCode } = response?.data || {};
    if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
      //get().GetTripPlanAction()
      getNotificationStyle(response);
      trackPromise(
        get().GetTripExceptionAction(data.tripId),
        "trip-exception-otp-area",
      );
    }
    return response;
  },
  //: Trip Schedule
  GetTripScheduleAction: async ({ page, size }) => {
    const response = await GetTripScheduleService({ page, size });
    const modifiedResponse = responseData(response?.data)?.map((item) => ({
      ...item,
      tripEndTimeT: moment(+item?.tripEndTime!).format("HH:mm"),
      tripStartTimeT: moment(+item?.tripStartTime!).format("HH:mm"),
      tripScheduleDetailsDtoList: item?.tripScheduleDetailsDtoList?.map(
        (tripScheduleDetailsDto: ITripScheduleDetail) => ({
          ...tripScheduleDetailsDto,
          originalEta: tripScheduleDetailsDto?.eta,
          originalDuration: tripScheduleDetailsDto?.estimatedMin,
          status: Boolean(item?.statusId),
        }),
      ) as ITripScheduleDetail[],
      children: item?.tripScheduleDetailsDtoList?.map(
        (tripScheduleDetailsDto: ITripScheduleDetail) => ({
          ...tripScheduleDetailsDto,
          etaT: moment(+tripScheduleDetailsDto?.eta!).format("HH:mm"),
        }),
      ) as ITripScheduleDetail[],
    }));
    set({ tripSchedules: modifiedResponse });
    return response;
  },
  GetTripActualAction: async ({ page, size }) => {
    const response = await GetTripActualScheduleService({ page, size });
    const modifiedResponse = responseData(response?.data)?.map((item) => ({
      ...item,
      // tripEndTimeT: moment(+item?.tripEndTime!).format("HH:mm"),
      // tripStartTimeT: moment(+item?.tripStartTime!).format("HH:mm"),
      // tripEndTime: convertMillisToDateMoment(item?.tripEndTime),
      // tripStartTime: convertMillisToDateMoment(item?.tripStartTime),
      tripActualLsDetailsDtoList: item?.tripActualLsDetailsDtoList?.map(
        (tripActualLsDetailsDto: ITripActualDetails) => ({
          ...tripActualLsDetailsDto,
          originalEta: tripActualLsDetailsDto?.eta,
          originalDuration: tripActualLsDetailsDto?.estimatedMin,
          status:
            tripActualLsDetailsDto?.statusId === ACTIVE_TRIP_STATUS_ID
              ? true
              : false,
        }),
      ) as ITripActualDetails[],
      children: item?.tripActualLsDetailsDtoList?.map(
        (tripActualLsDetailsDto: ITripActualDetails) => ({
          ...tripActualLsDetailsDto,
          etaT: moment(+tripActualLsDetailsDto?.eta).format("HH:mm"),
          estimatedMinT: moment(tripActualLsDetailsDto?.estimatedMin).format(
            "mm",
          ),
        }),
      ) as ITripActualDetails[],
    }));
    set({ tripActuals: modifiedResponse });
    return response;
  },
  SaveTripScheduleAction: async (request: ITripSchedule) => {
    const response = await SaveTripScheduleService(request);
    const { statusCode } = response?.data || {};
    if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
      set({ saveTripScheduleStatus: statusCode });
      getNotificationStyle(response);
      trackPromise(get().GetTripScheduleAction(), "trip-schedule-area");
    }
  },
  DeleteTripActualAction: async (request: IDeleteTripSchedule) => {
    const response = await DeleteTripActualService(request);
    const { statusCode } = response?.data || {};
    if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
      set({ saveTripScheduleStatus: statusCode });
      getNotificationStyle(response);
      trackPromise(get().GetTripScheduleAction(), "trip-schedule-area");
    }
  },
  UpdateTripScheduleAction: async (
    request: Pick<
      ITripSchedule,
      | "id"
      | "consigneeId"
      | "subClientId"
      | "statusId"
      | "scheduleTypeId"
      | "tripScheduleDetailsDtoList"
    >,
  ) => {
    const response = await UpdateTripScheduleService(request);
    const { statusCode } = response?.data || {};
    if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
      set({ updateTripScheduleStatus: statusCode });
      getNotificationStyle(response);
      trackPromise(get().GetTripScheduleAction(), "trip-schedule-area");
      get().GetTripActualAction();
    }
  },
  UpdateTripActualAction: async (request: ITripActual) => {
    const response = await UpdateTripActualService(request);
    const { statusCode } = response?.data || {};
    if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
      set({ updateTripActualStatus: statusCode });
      getNotificationStyle(response);
      trackPromise(get().GetTripActualAction(), "trip-actual-promise");
    }
  },
  RefreshActualTripAction: async (request: IRefresh) => {
    const response = await RefreshActualTripService(request);
    const { statusCode } = response?.data || {};
    if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
      getNotificationStyle(response);
      trackPromise(get().GetTripActualAction(), "trip-actual-promise");
    }
  },
  AssignScheduleDriverAction: async (request: IAssignDriver) => {
    const response = await AssignScheduleDriverService(request);
    const { statusCode } = response?.data || {};
    //set({ tripHistoryList: convertedResponse })
    if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
      set({ assignDriverStatus: statusCode });
      getNotificationStyle(response?.data);
      trackPromise(get().GetTripScheduleAction(), "trip-actual-promise");
    }
  },
  GetTripOtpListAction: async (id: number) => {
    set({ tripOtpList: {} });
    const response = await GetTripOtpListService(id);
    const convertedResponse = responseData(response?.data);
    set({ tripOtpList: convertedResponse });
  },
  UpdateAdhocDetailAction: async (data: IAdhocDetails, id: number) => {
    const response = await UpdateAdhocDetailService(data, id);
    const { statusCode } = response?.data || {};
    if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
      getNotificationStyle(response);
      trackPromise(
        get().GetTripPlanByIdAction(id),
        "trip-plan-by-id-list-area",
      );
    }
  },
  SaveTripPlanDriverWebAction: async (request: ITripplanDriverWeb) => {
    const response = await SaveTripPlanDriverWebService(request);
    const { statusCode } = response?.data || {};
    if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
      // set({ saveTripScheduleStatus: statusCode })
      getNotificationStyle(response);
      trackPromise(
        get().GetTripPlanDriverListByIdAction(request?.tripId),
        "adhoc-area",
      );
      trackPromise(
        get().GetTripPlanByIdAction(request?.tripId),
        "trip-plan-by-id-list-area",
      );
    }
  },
  GetTripPlanDriverListByIdAction: async (id: number) => {
    const response = await GetTripPlanDriverListByIdService(id);
    const convertedResponse = responseData(response?.data);
    set({ tripplanDriverList: convertedResponse });
  },
  PrintTripPlanAction: async (id: number | undefined) => {
    const response = await PrintTripPlanService(id);
    const { statusCode, data } = response?.data || {};
    if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
      trackPromise(downloadURL(data?.response), "tripplan-list-area");
    }
  },
  PrintTripSheetAction: async (id: number | undefined) => {
    const response = await PrintTripSheetService(id);
    const { statusCode, data } = response?.data || {};
    if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
      trackPromise(downloadURL(data?.response), "tripplan-list-area");
    }
  },
  PrintManifestSheetAction: async (id: number | undefined) => {
    const response = await PrintManifestSheetService(id);
    const { statusCode, data } = response?.data || {};
    if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
      trackPromise(downloadURL(data?.response), "tripplan-list-area");
    }
  },
  GetWaybillByTripPlanAction: async (tripNumber?: string) => {
    const response = await GetWaybillByTripPlanService(tripNumber);
    const data = responseData(response?.data)?.map((item) => ({
      ...item,
      id: item?.waybillNo,
      goodTypeId: item?.commodityId,
      price: item?.totalCharge,
    }));
    set({ tripPlanWayBills: data });
  },
  // GetTrailerListAction: async () => {
  //   const response = await getTrailerListService();
  //   set({ trailerList: responseData(response?.data) });
  // },

  GetDriverDetailAction: async (id?: number) => {
    if (!id) return set({ driverDetail: {} });
    const response = await GetDriverDetailByIdService(id);
    set({ driverDetail: responseData(response?.data) });
  },
  GetTruckListAction: async () => {
    const response = await GetVehicleListService(vehicleListType.TRUCK);
    set({ truckList: responseData(response?.data) });
  },
  GetTrailerHeadListAction: async () => {
    const response = await GetVehicleListService(vehicleListType.TRACTOR_HEAD);
    set({ trailerHeadList: responseData(response?.data) });
  },
  GetTrailerListAction: async () => {
    const response = await GetVehicleListService(vehicleListType.TRAILER);
    set({ trailerList: responseData(response?.data) });
  },
  PrintVehicleManifestAction: async (id: number | undefined) => {
    const response = await PrintVehicleManifestService(id);
    const { statusCode, data } = response?.data || {};
    if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
      trackPromise(downloadURL(data?.response), "tripplan-list-area");
    }
  },
  GetTripExceptionAction: async (id: string) => {
    const response = await trackPromise(
      GetTripExceptionService(id),
      "get-trip-exception-area",
    );
    const { statusCode, data } = response?.data || {};
    if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
      set({ tripExceptionList: data });
    } else {
      set({ tripExceptionList: [] });
    }
  },
  onFilterTripDashboard: (key, value) =>
    set((state) => ({
      tripPlanDashboard: {
        ...state.tripPlanDashboard,
        dashboardFilter: {
          ...state.tripPlanDashboard.dashboardFilter,
          [key]: value,
        },
      },
    })),
  ClearStore: () => {
    set(initialValue);
  },
  ClearTripDetailStore: () => {
    set({ tripplanDetailList: initialValue.tripplanDetailList });
  },
}));

export const useTripPlanStore = TripPlanStore;
